/* eslint-disable no-underscore-dangle */
const AmazonCognitoIdentity = require('amazon-cognito-identity-js');


const SignInAuthChallenge = (username) => {
  const poolData = {
    UserPoolId: process.env.VUE_APP_AWS_USER_POOL_ID, // Your user pool id here
    ClientId: process.env.VUE_APP_AWS_USER_CLIENT_ID, // Your client id here
  };

  const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

  const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails({
    Username: username,
  });

  const userData = {
    Username: username,
    Pool: userPool,
  };
  const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
  cognitoUser.setAuthenticationFlowType('CUSTOM_AUTH');

  const cognitoIdentityServiceProvider = new AWS.CognitoIdentityServiceProvider(
    {
      accessKeyId: process.env.VUE_APP_AWS_IAM_USER_KEY,
      secretAccessKey: process.env.VUE_APP_AWS_IAM_USER_SECRET,
      region: 'us-east-1',
    },
  );

  const params = {
    AuthFlow: 'CUSTOM_AUTH',
    ClientId: process.env.VUE_APP_AWS_USER_CLIENT_ID,
    AuthParameters: {
      USERNAME: username,
    }, /* ,
    UserContextData: {
      EncodedData: '1111'
    } */
  };

  return new Promise((resolve, reject) => {
    // eslint-disable-next-line func-names


    cognitoIdentityServiceProvider.initiateAuth(params, (err, data) => {
      if (err) {

        return reject(err);
      }


      return resolve(data);
    });
  });
};

export {
  SignInAuthChallenge as
  default,
};
